import React, { Component } from 'react';
import './_styles.scss';

class LayoutTwoAddOn extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { groups: imagesAddOn = [] } = this.props || {};

		return (
			<div className="landing-comercial-2-addon landing-comercial-2-addon--flex">
				<div className="landing-comercial-2-addon__left">
					<img className="landing-comercial-2-addon__img" src={imagesAddOn[0].images.vertical} alt="AddOn-1" />
				</div>
				<div className="landing-comercial-2-addon__right">
					<img className="landing-comercial-2-addon__img" src={imagesAddOn[1].images.vertical} alt="AddOn-2" />
				</div>
			</div>
		);
	}
}
export default LayoutTwoAddOn;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialAddOn/Components/LayoutTwoAddOn/index.jsx